// Step1.jsx
import React from "react";
import CustomInput from "../Inputs/CustomInput";
import PrimaryButton from "../Buttons/PrimaryButton";
import SubmitButton from "../Buttons/SubmitButton";
import PhoneInputField from "../Inputs/PhoneInput";
import CustomSelect from "../Inputs/CustomSelect";

const Step1 = ({
  register,
  errors,
  personType,
  setPersonType,
  navigate,
  nextStep,
  setValue,
}) => {
  return (
    <>
      {/* 1ère étape : Informations personnelles */}
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">
          Type de personne <span className="text-red-500">*</span>
        </label>
        <div className="flex space-x-4">
          <button
            type="button"
            onClick={() => setPersonType("physique")}
            className={`py-2 px-4 rounded ${
              personType === "physique"
                ? "bg-orange-600 text-white"
                : "bg-gray-200"
            }`}
          >
            Personne physique
          </button>
          <button
            type="button"
            onClick={() => setPersonType("morale")}
            className={`py-2 px-4 rounded ${
              personType === "morale"
                ? "bg-orange-600 text-white"
                : "bg-gray-200"
            }`}
          >
            Personne morale
          </button>
        </div>
      </div>

      {personType && (
        <>
          {personType === "morale" && (
            <CustomInput
              label="Raison sociale"
              type="text"
              id="raisonSociale"
              register={register}
              errors={errors}
              validation={{
                pattern: {
                  value: /^[\w\s-À-ÖØ-öø-ÿ]+$/,
                  message: "Pas de caractères spéciaux sauf '-'",
                },
              }}
              placeholder="Entrez la raison sociale"
              required
            />
          )}

          {personType === "physique" && (
            <>
              <CustomInput
                label="Nom"
                type="text"
                id="lastName"
                register={register}
                errors={errors}
                validation={{
                  pattern: {
                    value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s-]+$/,
                    message: "Uniquement des lettres",
                  },
                }}
                placeholder="Entrez votre nom"
                required
              />
              <CustomInput
                label="Prénom"
                type="text"
                id="firstName"
                register={register}
                errors={errors}
                validation={{
                  pattern: {
                    value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s-]+$/,
                    message: "Uniquement des lettres",
                  },
                }}
                placeholder="Entrez votre prénom"
                required
              />
            </>
          )}

          <div className="mb-4">
            {/* <label className="block text-sm font-medium mb-2">Adresse postale <span className="text-red-500">*</span></label> */}
            <CustomInput
              label="Rue"
              type="text"
              id="street"
              register={register}
              errors={errors}
              validation={{
                pattern: {
                  value: /^[\w\s-À-ÖØ-öø-ÿ,]+$/,
                  message: "Pas de caractères spéciaux sauf '-' et ','",
                },
              }}
              placeholder="Entrez votre rue"
              required
            />
            <CustomInput
              label="Ville"
              type="text"
              id="city"
              register={register}
              errors={errors}
              validation={{
                pattern: {
                  value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s-]+$/,
                  message: "Pas de caractères spéciaux ni chiffres sauf '-'",
                },
              }}
              placeholder="Entrez votre ville"
              required
            />
            {/* <CustomInput
              label="Pays"
              type="text"
              id="country"
              register={register}
              errors={errors}
              validation={{
                pattern: {
                  value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s-]+$/,
                  message: "Pas de caractères spéciaux ni chiffres sauf '-'",
                },
              }}
              placeholder="Entrez votre pays"
              required
            /> */}
            <CustomSelect
              label="Pays"
              type="select"
              id="country"
              register={register}
              errors={errors}
              required={true}
            />
          </div>

          <PhoneInputField
            label={"Numéro de téléphone principal"}
            id="phone"
            register={register}
            setValue={setValue}
            errors={errors}
            placeholder="Numéro de téléphone"
            required={true}
          />

          <PhoneInputField
            label={"Numéro de téléphone secondaire"}
            id="secondaryPhone"
            register={register}
            setValue={setValue}
            errors={errors}
            placeholder="Numéro de téléphone"
            required={false}
          />

          <CustomInput
            label="Adresse e-mail"
            type="email"
            id="email"
            register={register}
            errors={errors}
            validation={{
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Veuillez entrer un email valide",
              },
            }}
            placeholder="Entrez votre email"
            required
          />

          <div className="flex justify-between mt-4">
            <PrimaryButton
              type="button"
              label="Retour"
              onClick={() => setPersonType(null)}
              className="py-2 px-4 bg-gray-600 text-white rounded"
            />
            <SubmitButton type="button" onClick={nextStep} label="Suivant" />
          </div>
        </>
      )}
    </>
  );
};

export default Step1;
